import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { TertiaryButton } from 'common/button'
import { useLesson } from 'querys/lesson'
import Reaction from './reaction'

const ReactionListStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(4, min-content);
  grid-template-rows: 45px;
  grid-column-gap: 12px;
  align-items: center;
  margin: 8px 0;
  button {
    margin-left: -16px;
  }
  @media screen and (min-width: 768px) {
    grid-column-gap: 24px;
  }
  @media screen and (min-width: 1024px) {
    button {
      /* padding: initial; */
      /* grid-column-start: auto; */
      /* grid-column-end: auto; */
      /* margin: 0; */
    }
  }
`

const reactComments = [
  {
    message: 'Like',
    left: -12,
    name: 'like',
    value: 'likes',
  },
  {
    message: 'Qué trucazo',
    name: 'wand',
    value: 'wands',
    width: 104,
  },
  {
    message: 'No te rindas',
    name: 'nogiveup',
    value: 'nogiveups',
    width: 104,
  },
]

function ReactCommentList({
  handleReplyForm,
  isReply,
  replyActive,
  reactionsCounter,
  reactions,
  onReaction,
}) {
  const { data: { has_access: hasAccess }, token } = useLesson()
  if (!token || !hasAccess) return null
  return (
    <ReactionListStyled data-cy="reactions-list">
      {reactComments.map((item) => (
        <Reaction
          onReaction={onReaction}
          key={`idx-${item.name}`}
          message={item.message}
          reactionCounter={item.value}
          count={reactionsCounter[item.value]}
          reacted={reactions[item.name]}
          reaction={item.name}
          left={item.left}
          width={item.width}
        />
      ))}
      {!replyActive && token && !isReply && (
        <TertiaryButton font="var(--secondaryFont)" fontWeight={500} color="var(--secondary)" onClick={() => handleReplyForm()}>
          {'Responder'}
        </TertiaryButton>
      )}
    </ReactionListStyled>
  )
}
ReactCommentList.defaultProps = {
  isReply: false,
}

ReactCommentList.propTypes = {
  isReply: PropTypes.bool,
  handleReplyForm: PropTypes.func.isRequired,
  replyActive: PropTypes.bool.isRequired,
  reactionsCounter: PropTypes.shape({
    likes: PropTypes.number,
    nogiveups: PropTypes.number,
    wands: PropTypes.number,
  }).isRequired,
  reactions: PropTypes.shape({
    like: PropTypes.bool,
    nogiveup: PropTypes.bool,
    wand: PropTypes.bool,
  }).isRequired,
  onReaction: PropTypes.func.isRequired,
}

export default ReactCommentList
